
import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import '../styles/createcode.css'
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import { CSVLink } from "react-csv";
import '../styles/chargewallet.css'
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { BASE_URL } from "../App";
import QRCode from 'qrcode';



function ChargeWallet () {
    const navigate = useNavigate();

    const [filteredData, setFilteredData] = useState([]);
    const [codeTable , setCodeTable] = useState([]);
    const [walletBalance, setWalletBalance] = useState(0);
    const [code, setCode] = useState("");
    const [fawryAmount, setFawryAmount] = useState("");
    const [walletAmount, setWalletAmount] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("3"); // Default to Fawry (3)
    const [errors , setErrors] = useState("")
    const [isLoading , setIsLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const token = localStorage.getItem('token');
    const axiosInstance = axios.create({
      baseURL: `${BASE_URL}`,
      headers: {
          'Content-Type': 'application/json',
          "ngrok-skip-browser-warning": "any",
          Authorization: `Bearer ${token}`,
      },
  });

        // الريكويست الخاص بعرض الأكواد المشحونة
          const getcodes = async () => {
              try {
                const response = await axiosInstance.get('/api/my-codes');
                  setWalletBalance(response.data.message);
                  setCodeTable(response.data.data)
                  setIsLoading(false)
                  const data = response.data.data;
                          return data;
              } catch (error) {
                setIsLoading(false)

              }
          }
          useEffect (() =>{
            getcodes();
          }, [])


          // الريكويست الخاص ب شحن الكود وسعة المحفظة

  const handleCharge = async (event) => {
    event.preventDefault();
    try {
     const response =  await axiosInstance.post("/api/codes/charge" , {
          code
             
        });
        setCode("")
        swal({
            title: "تم الشحن بنجاح!",
            icon: "success",
            button: "حسناّ!",
          });
          const chargedCode = response.data.data;
          setWalletBalance(prevBalance => prevBalance + chargedCode.value);
          setCodeTable(prevTable => [...prevTable, chargedCode]);

    } catch(e) {
        if(e.response.status === 401) {
          swal({
            title: "تم شحن هذا الكود من قبل!",
            icon: "warning",
            button: "حسناّ!",
          });
            setErrors(e.response.data.errors);
        }
       else if(e.response.status === 404) {
          swal({
            title: "  هذا الكود  غير صحيح!",
            icon: "warning",
            button: "حسناّ!",
          });
            setErrors(e.response.data.errors);
        }
      
    }
}

// فحص أمني شامل لمبلغ فوري
const detectWalletXSS = (amount) => {
  const dangerousPatterns = /<script|javascript:|on\w+\s*=|data:text\/html/i;
  return dangerousPatterns.test(amount);
};

// التحقق من صحة مبلغ فوري
const validateFawryAmount = (amount) => {
  const numAmount = parseFloat(amount);
  return !isNaN(numAmount) && numAmount >= 1 && numAmount <= 10000 && Number.isInteger(numAmount);
};

// تنظيف المدخلات
const secureWalletInput = (input, type) => {
  if (type === 'amount') {
    return parseFloat(input).toString();
  }
  return input.toString().replace(/[<>]/g, '');
};

const chargeBalanceWithPayment = async (event) => {
  event.preventDefault();
  
  // فحص أمني شامل للمبلغ
  if (!fawryAmount || fawryAmount <= 0) {
    swal("خطأ!", "يرجى إدخال مبلغ صحيح للشحن.", "warning");
    return;
  }
  
  if (detectWalletXSS(fawryAmount)) {
    swal("خطأ أمني!", "المبلغ يحتوي على محتوى غير آمن", "error");
    return;
  }
  
  if (!validateFawryAmount(fawryAmount)) {
    swal("خطأ!", "المبلغ غير صحيح. يجب أن يكون رقم صحيح بين 1 و 10000", "warning");
    return;
  }
  
  // تنظيف المبلغ قبل الاستخدام
  const sanitizedAmount = secureWalletInput(fawryAmount, 'amount');
  
  // عرض SweetAlert للاختيار بين طرق الدفع
  swal({
    title: `اختر طريقة الدفع لشحن ${sanitizedAmount} جنيه`,
    text: "اختر الطريقة المناسبة لك",
    icon: "info",
    buttons: {
      fawry: {
        text: "كود فوري",
        value: "fawry",
        className: "btn btn-warning"
      },
      wallet: {
        text: "محفظة الكترونية",
        value: "wallet",
        className: "btn btn-success"
      },
      cancel: {
        text: "إلغاء",
        value: null,
        className: "btn btn-secondary"
      }
    },
    closeOnClickOutside: false,
  }).then(async (selectedMethod) => {
    if (selectedMethod === "fawry") {
      // فوري
      await processFawryPayment(sanitizedAmount);
    } else if (selectedMethod === "wallet") {
      // محفظة
      if (!phoneNumber || phoneNumber.trim() === '') {
        swal("خطأ!", "يرجى إدخال رقم الهاتف", "warning");
        return;
      }
      await processWalletPayment(sanitizedAmount);
    }
  });
};

const processFawryPayment = async (amount) => {
  swal({
    title: `هل أنت متأكد من الشحن بـ فوري؟`,
    text: `سيتم إنشاء كود فوري لشحن ${amount} جنيه. ملحوظة: قد يستغرق وصول الرصيد من نصف ساعة إلى ساعة.`,
    icon: "warning",
    buttons: ["إلغاء", "تأكيد"],
    dangerMode: true,
  }).then(async (ok) => {
    if (ok) {
      setIsSubmitting(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${BASE_URL}/api/fawaterak-pay-initiation/wallet`,
          {
            total: amount,
            payment_method_id: 3
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        const fawryCode = response?.data?.data?.data?.payment_data?.fawryCode;
        if (fawryCode) {
          navigate("/payment", { state: { paymentData: fawryCode } });
        }
      } catch (error) {
        swal(
          "خطأ!",
          "لم نتمكن من إنشاء كود فوري. يرجى المحاولة مرة أخرى.",
          "error"
        );
      } finally {
        setIsSubmitting(false);
      }
    }
  });
};

const processWalletPayment = async (amount) => {
  if (!phoneNumber || phoneNumber.trim() === '') {
    swal("خطأ!", "يرجى إدخال رقم الهاتف", "warning");
    return;
  }

  swal({
    title: `هل أنت متأكد من الشحن من المحفظة؟`,
    text: `سيتم إنشاء طلب شحن لـ ${amount} جنيه على رقم ${phoneNumber}`,
    icon: "warning",
    buttons: ["إلغاء", "تأكيد"],
    dangerMode: true,
  }).then(async (ok) => {
    if (ok) {
      setIsSubmitting(true);
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${BASE_URL}/api/fawaterak-pay-initiation/wallet`,
          {
            total: amount,
            payment_method_id: 4,
            phone: phoneNumber
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        // عرض رسالة بسيطة
        swal({
          title: "تم إرسال طلب الشحن!",
          text: "بانتظار الدفع من المحفظة الخاصة بك",
          icon: "success",
          button: "حسناّ!",
        });
        
        setFawryAmount("");
        setPhoneNumber("");
      } catch (error) {
        swal(
          "خطأ!",
          "لم نتمكن من إتمام عملية الشحن. يرجى المحاولة مرة أخرى.",
          "error"
        );
      } finally {
        setIsSubmitting(false);
      }
    }
  });
};

useEffect(() => {
  window.scrollTo(0, 0);
}, []);




function formatDate(dateString) {
  try {
    const date = new Date(dateString);
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: 'UTC',
      numberingSystem: 'arab'
    };
    const formatter = new Intl.DateTimeFormat('ar-EG', options);
    const formattedDate = formatter.format(date);
    return formattedDate;
  } catch (e) {
    return '';
  }
}
            
      const columns = [
           {
              name: "ID-codes ",
              selector: (row) => row.id,
              sortable : true,
            },
          {
              name: "Code",
              selector: (row) => row.code,
              sortable : true,
            },
     
          {
              name: "Price",
              selector: (row) => row.value,
              sortable : true,
            }, 
          {
              name: "Charged At",
              selector: (row) =>  row.updated_at,
          
              sortable : true,
            }, 
      ];


  
    return (
        <>
           {
          isLoading
          ?
           <div className="main-loading">
           <div className="loading-course"> 
         <h2>  .... جاري تحميل  بيانات رصيدك</h2>
         </div>
         </div>
         :
         <div className="charge-wallet ">
         <div className="main-title">شحن المحفظة</div>
         <Container>
             <Row>
             <Col lg={12}>
                        <div className="quiz-content">
                          
                          <div className="fawry-charge-section">
         <h4 className="fawry-title">شحن المحفظة</h4>
         
         {/* صف الفوري */}
         <div className="payment-row fawry-row">
           <h5 className="payment-method-title">
             <i className="fas fa-credit-card"></i>
             كود فوري
           </h5>
           <Form className="fawry-form" onSubmit={(e) => {
             e.preventDefault();
             if (!fawryAmount || fawryAmount <= 0) {
               swal("خطأ!", "يرجى إدخال مبلغ صحيح للشحن.", "warning");
               return;
             }
             processFawryPayment(fawryAmount);
           }}>
             <Row>
               <Col md={8}>
                 <Form.Group className="mb-3" controlId="formBasicAmount">
                   <Form.Label>مبلغ الشحن (جنيه)</Form.Label>
                   <Form.Control 
                     type="number" 
                     placeholder="ادخل المبلغ المطلوب شحنه" 
                     value={fawryAmount}
                     onChange={(e) => setFawryAmount(e.target.value)}
                     min="1"
                     max="10000"
                   />
                 </Form.Group>
               </Col>
               
               <Col md={4}>
                 <div className="d-flex align-items-center h-100">
                   <Button 
                     variant="warning" 
                     type="submit" 
                     className="fawry-btn w-100"
                     disabled={isSubmitting}
                   >
                     {isSubmitting ? "جاري التحميل..." : "شحن فوري"}
                   </Button>
                 </div>
               </Col>
             </Row>
           </Form>
         </div>
         
         {/* صف المحفظة */}
         <div className="payment-row wallet-row">
           <h5 className="payment-method-title">
             <i className="fas fa-wallet"></i>
             محفظة إلكترونية
           </h5>
           <Form className="wallet-form" onSubmit={(e) => {
             e.preventDefault();
             if (!walletAmount || walletAmount <= 0) {
               swal("خطأ!", "يرجى إدخال مبلغ صحيح للشحن.", "warning");
               return;
             }
             if (!phoneNumber || phoneNumber.trim() === '') {
               swal("خطأ!", "يرجى إدخال رقم الهاتف", "warning");
               return;
             }
             processWalletPayment(walletAmount);
           }}>
             <Row>
               <Col md={4}>
                 <Form.Group className="mb-3" controlId="formBasicWalletAmount">
                   <Form.Label>مبلغ الشحن (جنيه)</Form.Label>
                   <Form.Control 
                     type="number" 
                     placeholder="ادخل المبلغ" 
                     value={walletAmount}
                     onChange={(e) => setWalletAmount(e.target.value)}
                     min="1"
                     max="10000"
                   />
                 </Form.Group>
               </Col>
               
               <Col md={4}>
                 <Form.Group className="mb-3" controlId="formBasicPhone">
                   <Form.Label>رقم الهاتف <span className="required">*</span></Form.Label>
                   <Form.Control 
                     type="tel" 
                     placeholder="ادخل رقم هاتفك" 
                     value={phoneNumber}
                     onChange={(e) => setPhoneNumber(e.target.value)}
                     pattern="[0-9]{11}"
                     maxLength="11"
                     required
                   />
                 </Form.Group>
               </Col>
               
               <Col md={4}>
                 <div className="d-flex align-items-center h-100">
                   <Button 
                     variant="success" 
                     type="submit" 
                     className="wallet-btn w-100"
                     disabled={isSubmitting}
                   >
                     {isSubmitting ? "جاري التحميل..." : "شحن محفظة"}
                   </Button>
                 </div>
               </Col>
             </Row>
           </Form>
         </div>
       </div>
       
       <div className="codes">
                          <Form className="align-items-center" onSubmit={handleCharge}>
         <Form.Group className="mb-3" controlId="formBasicEmail">
           <Form.Label> كود الشحن </Form.Label>
           <Form.Control type="text" placeholder="ادخل  كود الشحن" name="code" onChange={(e)=>{setCode(e.target.value)}}/>
         </Form.Group>
         <Button variant="outline-primary" type="submit" className="ms-lg-4 ms-0">اشحن</Button>{' '}
       </Form>
       
       <div className="wallet">
         <span>رصيدك بالمحفظة  </span>
                                               
                     <span> {walletBalance} جنيها</span>
               </div>
            
               <DataTable
                  columns={columns}
                  data={filteredData.length > 0 ? filteredData : codeTable} 
                   pagination 
                   fixedHeader
                   fixedHeaderScrollHeight="400px"
                   highlightOnHover
                   subHeader
                   />
                   
                           </div> 
                 </div>
                       </Col>
               </Row>
           </Container>
   
       
         </div>
           }
    
      
        </>
        
    )
}

export default ChargeWallet;